(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marianistaInitContactoVisitaModal = marianistaInitContactoVisitaModal;
/**
 * Modal — formulario de visita guiada (página Contacto).
 */
function marianistaInitContactoVisitaModal() {
  var modal = document.getElementById('visitaModal');
  if (!modal) {
    return;
  }
  var closeBackdrop = document.getElementById('closeVisitaModal');
  var closeBtn = document.getElementById('closeVisitaModalBtn');
  var form = modal.querySelector('#visitaModalForm, form.wpcf7-form');
  var waBtn = document.getElementById('visitaModalWaBtn');
  var openModal = function openModal(event) {
    if (event) {
      event.preventDefault();
    }
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var firstField = form === null || form === void 0 ? void 0 : form.querySelector('input, select, textarea');
    if (firstField instanceof HTMLElement) {
      window.setTimeout(function () {
        return firstField.focus();
      }, 60);
    }
  };
  var closeModal = function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };
  var triggerSelector = ['[data-open-visita-modal]', '#openVisitaModal', 'a[href="#visitaModal"]', 'a[href="#openVisitaModal"]'].join(', ');
  document.addEventListener('click', function (event) {
    var trigger = event.target instanceof Element ? event.target.closest(triggerSelector) : null;
    if (!trigger) {
      return;
    }
    openModal(event);
  });
  closeBackdrop === null || closeBackdrop === void 0 || closeBackdrop.addEventListener('click', closeModal);
  closeBtn === null || closeBtn === void 0 || closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
  function buildVisitaMessage() {
    if (!form) {
      return '';
    }
    var fd = new FormData(form);
    var get = function get(name) {
      return (fd.get(name) || fd.get(name.replace(/_/g, '-')) || '').toString().trim();
    };
    var nombre = get('padre_nombre') || get('padre-nombre');
    var tel = get('telefono');
    var correo = get('correo');
    var nivel = get('nivel');
    var fecha = get('fecha_preferida') || get('fecha-preferida');
    var mensaje = get('mensaje');
    var lines = ['Hola, quisiera agendar una visita guiada.', nombre ? "Nombre: ".concat(nombre) : '', tel ? "Tel\xE9fono: ".concat(tel) : '', correo ? "Correo: ".concat(correo) : '', nivel ? "Nivel de inter\xE9s: ".concat(nivel) : '', fecha ? "Fecha preferida: ".concat(fecha) : '', mensaje ? "Mensaje: ".concat(mensaje) : ''].filter(Boolean);
    return lines.join('\n');
  }
  if (form instanceof HTMLFormElement && form.id === 'visitaModalForm') {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
    });
  }
  waBtn === null || waBtn === void 0 || waBtn.addEventListener('click', function () {
    var base = (waBtn.getAttribute('data-wa-url') || '').trim();
    if (!base) {
      return;
    }
    var text = encodeURIComponent(buildVisitaMessage());
    var sep = base.includes('?') ? '&' : '?';
    window.open("".concat(base).concat(sep, "text=").concat(text), '_blank', 'noopener,noreferrer');
  });
}

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marianistaInitEgFotosGallery = marianistaInitEgFotosGallery;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Galería de fotos (página Egresados).
 *
 * - Splide en el preview (4 en 4 en desktop).
 * - Botón [data-open-fotos-modal] abre el modal galería.
 * - Modal lista de a 10 con paginador.
 * - Click en [data-foto-src] abre el lightbox.
 */
function marianistaInitEgFotosGallery() {
  var galleryModal = /** @type {HTMLElement|null} */document.getElementById('eg-fotos-modal');
  var lightbox = /** @type {HTMLElement|null} */document.getElementById('eg-lightbox');
  initEgFotosSplide();
  if (!galleryModal && !lightbox) return;

  /* ── Galería modal + paginación ── */
  var galleryBackdrop = document.getElementById('eg-fotos-modal-backdrop');
  var galleryClose = document.getElementById('eg-fotos-modal-close');
  var grid = /** @type {HTMLElement|null} */document.getElementById('eg-fotos-modal-grid');
  var pager = document.getElementById('eg-fotos-modal-pager');
  var pagerPrev = document.getElementById('eg-fotos-modal-prev');
  var pagerNext = document.getElementById('eg-fotos-modal-next');
  var pagerStatus = document.getElementById('eg-fotos-modal-status');
  var perPage = Math.max(1, Number((grid === null || grid === void 0 ? void 0 : grid.dataset.perPage) || 10));
  var galleryItems = grid ? _toConsumableArray(grid.querySelectorAll('.eg-fotos__item')) : [];
  var totalPages = Math.max(1, Math.ceil(galleryItems.length / perPage));
  var galleryPage = 1;
  var renderGalleryPage = function renderGalleryPage(page) {
    galleryPage = Math.min(Math.max(1, page), totalPages);
    var start = (galleryPage - 1) * perPage;
    var end = start + perPage;
    galleryItems.forEach(function (el, i) {
      el.hidden = i < start || i >= end;
    });
    if (pager) {
      var showPager = galleryItems.length > perPage;
      pager.hidden = !showPager;
      if (showPager) {
        if (pagerStatus) {
          pagerStatus.textContent = "".concat(galleryPage, " / ").concat(totalPages);
        }
        if (pagerPrev instanceof HTMLButtonElement) {
          pagerPrev.disabled = galleryPage <= 1;
        }
        if (pagerNext instanceof HTMLButtonElement) {
          pagerNext.disabled = galleryPage >= totalPages;
        }
      }
    }
  };
  renderGalleryPage(1);
  var openGallery = function openGallery() {
    if (!galleryModal) return;
    renderGalleryPage(1);
    galleryModal.classList.add('is-open');
    galleryModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    galleryClose instanceof HTMLElement && window.setTimeout(function () {
      return galleryClose.focus();
    }, 60);
  };
  var closeGallery = function closeGallery() {
    if (!galleryModal) return;
    galleryModal.classList.remove('is-open');
    galleryModal.setAttribute('aria-hidden', 'true');
    if (!(lightbox !== null && lightbox !== void 0 && lightbox.classList.contains('is-open'))) {
      document.body.style.overflow = '';
    }
  };
  document.addEventListener('click', function (e) {
    if (e.target instanceof Element && e.target.closest('[data-open-fotos-modal]')) {
      openGallery();
    }
  });
  galleryBackdrop === null || galleryBackdrop === void 0 || galleryBackdrop.addEventListener('click', closeGallery);
  galleryClose === null || galleryClose === void 0 || galleryClose.addEventListener('click', closeGallery);
  pagerPrev === null || pagerPrev === void 0 || pagerPrev.addEventListener('click', function () {
    return renderGalleryPage(galleryPage - 1);
  });
  pagerNext === null || pagerNext === void 0 || pagerNext.addEventListener('click', function () {
    return renderGalleryPage(galleryPage + 1);
  });

  /* ── Lightbox ── */
  /** @type {{ src: string; alt: string }[]} */
  var photos = [];
  var current = 0;
  var lbImg = /** @type {HTMLImageElement|null} */document.getElementById('eg-lightbox-img');
  var lbClose = document.getElementById('eg-lightbox-close');
  var lbBackdrop = document.getElementById('eg-lightbox-backdrop');
  var lbPrev = document.getElementById('eg-lightbox-prev');
  var lbNext = document.getElementById('eg-lightbox-next');
  var lbCounter = document.getElementById('eg-lightbox-counter');
  var updateNav = function updateNav() {
    if (lbPrev) {
      lbPrev.toggleAttribute('data-hidden', current === 0);
    }
    if (lbNext) {
      lbNext.toggleAttribute('data-hidden', current === photos.length - 1);
    }
    if (lbCounter) {
      lbCounter.textContent = photos.length > 1 ? "".concat(current + 1, " / ").concat(photos.length) : '';
    }
  };
  var showPhoto = function showPhoto(index) {
    current = index;
    if (lbImg) {
      lbImg.src = photos[current].src;
      lbImg.alt = photos[current].alt;
    }
    updateNav();
  };
  var openLightbox = function openLightbox(photoList, index) {
    if (!lightbox) return;
    photos = photoList;
    showPhoto(index);
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    lbClose instanceof HTMLElement && window.setTimeout(function () {
      return lbClose.focus();
    }, 60);
  };
  var closeLightbox = function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    if (!(galleryModal !== null && galleryModal !== void 0 && galleryModal.classList.contains('is-open'))) {
      document.body.style.overflow = '';
    }
  };

  /** Recoge todas las fotos del contenedor (incluye ocultas por paginación). */
  var collectPhotos = function collectPhotos(figure) {
    var container = figure.closest('.eg-fotos-modal__grid') || figure.closest('.eg-fotos__splide') || figure.closest('.eg-fotos__mosaico');
    if (!container) return [];
    return _toConsumableArray(container.querySelectorAll('[data-foto-src]')).map(function (el) {
      return {
        src: (/** @type {string} */el instanceof HTMLElement ? el.dataset.fotoSrc : ''),
        alt: (/** @type {string} */el instanceof HTMLElement ? el.dataset.fotoAlt || '' : '')
      };
    });
  };
  var photoContainer = function photoContainer(figure) {
    return figure.closest('.eg-fotos-modal__grid') || figure.closest('.eg-fotos__splide') || figure.closest('.eg-fotos__mosaico') || document;
  };
  document.addEventListener('click', function (e) {
    var figure = e.target instanceof Element ? e.target.closest('[data-foto-src]') : null;
    if (!figure) return;
    var list = collectPhotos(figure);
    var index = _toConsumableArray(photoContainer(figure).querySelectorAll('[data-foto-src]')).indexOf(figure);
    openLightbox(list, Math.max(0, index));
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var figure = e.target instanceof Element ? e.target.closest('[data-foto-src]') : null;
    if (!figure) return;
    e.preventDefault();
    figure.dispatchEvent(new MouseEvent('click', {
      bubbles: true
    }));
  });
  lbClose === null || lbClose === void 0 || lbClose.addEventListener('click', closeLightbox);
  lbBackdrop === null || lbBackdrop === void 0 || lbBackdrop.addEventListener('click', closeLightbox);
  lbPrev === null || lbPrev === void 0 || lbPrev.addEventListener('click', function () {
    if (current > 0) showPhoto(current - 1);
  });
  lbNext === null || lbNext === void 0 || lbNext.addEventListener('click', function () {
    if (current < photos.length - 1) showPhoto(current + 1);
  });
  document.addEventListener('keydown', function (e) {
    if (lightbox !== null && lightbox !== void 0 && lightbox.classList.contains('is-open')) {
      if (e.key === 'Escape') {
        closeLightbox();
        return;
      }
      if (e.key === 'ArrowLeft' && current > 0) showPhoto(current - 1);
      if (e.key === 'ArrowRight' && current < photos.length - 1) showPhoto(current + 1);
    } else if (galleryModal !== null && galleryModal !== void 0 && galleryModal.classList.contains('is-open') && e.key === 'Escape') {
      closeGallery();
    }
  });
}
function initEgFotosSplide() {
  if (typeof Splide === 'undefined') {
    return;
  }
  document.querySelectorAll('.eg-fotos__splide').forEach(function (el) {
    if (!(el instanceof HTMLElement) || el.dataset.egFotosMounted === '1') {
      return;
    }
    el.dataset.egFotosMounted = '1';
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var slideCount = el.querySelectorAll('.splide__slide').length;
    var multiPage = slideCount > 1;
    new Splide(el, {
      type: 'slide',
      perPage: 1,
      perMove: 1,
      gap: 0,
      pagination: multiPage,
      arrows: multiPage,
      drag: multiPage,
      speed: reducedMotion ? 0 : 450,
      easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)'
    }).mount();
  });
}

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marianistaInitEgRevistasModal = marianistaInitEgRevistasModal;
/**
 * Modal — todas las revistas (página Egresados).
 */
function marianistaInitEgRevistasModal() {
  var modal = document.getElementById('eg-revistas-modal');
  if (!modal) {
    return;
  }
  var backdrop = document.getElementById('eg-revistas-modal-backdrop');
  var closeBtn = document.getElementById('eg-revistas-modal-close');
  var openModal = function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn instanceof HTMLElement && window.setTimeout(function () {
      return closeBtn.focus();
    }, 60);
  };
  var closeModal = function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };
  document.addEventListener('click', function (event) {
    var trigger = event.target instanceof Element ? event.target.closest('[data-open-revistas-modal]') : null;
    if (trigger) {
      openModal();
    }
  });
  backdrop === null || backdrop === void 0 || backdrop.addEventListener('click', closeModal);
  closeBtn === null || closeBtn === void 0 || closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
}

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marianistaInitFaqAccordion = marianistaInitFaqAccordion;
/**
 * Acordeón FAQ — apertura/cierre suave (.sec-faq__item).
 */
function marianistaInitFaqAccordion() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }
  var DURATION = 400;
  var EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';
  document.querySelectorAll('.sec-faq__item').forEach(function (details) {
    if (!(details instanceof HTMLDetailsElement)) {
      return;
    }
    var summary = details.querySelector('.sec-faq__question');
    var panel = details.querySelector('.sec-faq__panel');
    var inner = panel === null || panel === void 0 ? void 0 : panel.querySelector('.sec-faq__answer');
    if (!summary || !panel || !inner) {
      return;
    }
    if (details.dataset.faqAnim === '1') {
      return;
    }
    details.dataset.faqAnim = '1';
    panel.style.overflow = 'hidden';
    panel.style.transition = "max-height ".concat(DURATION, "ms ").concat(EASING);
    var animating = false;
    var panelHeight = function panelHeight() {
      return inner.scrollHeight;
    };
    var setHeight = function setHeight(px) {
      panel.style.maxHeight = typeof px === 'number' ? "".concat(px, "px") : px;
    };
    var syncClosed = function syncClosed() {
      setHeight(0);
    };
    var syncOpen = function syncOpen() {
      setHeight(panelHeight());
    };
    if (details.open) {
      details.open = true;
      syncOpen();
    } else {
      syncClosed();
    }
    summary.addEventListener('click', function (event) {
      event.preventDefault();
      if (animating) {
        return;
      }
      if (details.open) {
        animating = true;
        setHeight(panelHeight());
        panel.getBoundingClientRect();
        setHeight(0);
        var _onEnd = function onEnd(e) {
          if (e.target !== panel || e.propertyName !== 'max-height') {
            return;
          }
          panel.removeEventListener('transitionend', _onEnd);
          details.open = false;
          syncClosed();
          animating = false;
        };
        panel.addEventListener('transitionend', _onEnd);
        return;
      }
      animating = true;
      details.open = true;
      syncClosed();
      requestAnimationFrame(function () {
        panel.getBoundingClientRect();
        setHeight(panelHeight());
        var _onEnd2 = function onEnd(e) {
          if (e.target !== panel || e.propertyName !== 'max-height') {
            return;
          }
          panel.removeEventListener('transitionend', _onEnd2);
          setHeight('none');
          animating = false;
        };
        panel.addEventListener('transitionend', _onEnd2);
      });
    });
    window.addEventListener('resize', function () {
      if (details.open && !animating) {
        setHeight(panelHeight());
      }
    });
  });
}

},{}],5:[function(require,module,exports){
"use strict";

var _infraModal = require("./infra-modal.js");
var _ipVidaLightbox = require("./ip-vida-lightbox.js");
var _primGaleria = require("./prim-galeria.js");
var _faqAccordion = require("./faq-accordion.js");
var _contactoVisitaModal = require("./contacto-visita-modal.js");
var _egRevistasModal = require("./eg-revistas-modal.js");
var _egFotosGallery = require("./eg-fotos-gallery.js");
/**
 * Navegación móvil y Splide (hero)
 */
var navToggle = document.getElementById('nav-toggle');
var navMenu = document.getElementById('nav-menu');
var marianistaNavMobileMq = window.matchMedia('(max-width: 768px)');
function marianistaNavIsMobile() {
  return marianistaNavMobileMq.matches;
}
if (navToggle && navMenu) {
  navToggle.addEventListener('click', function () {
    navToggle.classList.toggle('activo');
    navMenu.classList.toggle('activo');
    if (!navMenu.classList.contains('activo')) {
      document.querySelectorAll('.nav__item--dropdown').forEach(function (item) {
        item.classList.remove('activo');
        var btn = item.querySelector('.nav__dropdown-toggle');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }
  });
  document.querySelectorAll('.nav__item--dropdown').forEach(function (item) {
    var toggle = item.querySelector('.nav__dropdown-toggle');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (!marianistaNavIsMobile()) return;
      var open = item.classList.toggle('activo');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
}
var heroEl = document.getElementById('hero-splide');
if (heroEl && typeof Splide !== 'undefined') {
  new Splide(heroEl, {
    type: 'fade',
    rewind: true,
    autoplay: true,
    interval: 6000,
    speed: 900,
    pauseOnHover: true,
    arrows: true,
    pagination: true,
    keyboard: true,
    lazyLoad: 'nearby'
  }).mount();
}
document.querySelectorAll('.ip-vida__splide').forEach(function (el) {
  if (typeof Splide === 'undefined') {
    return;
  }
  new Splide(el, {
    type: 'carousel',
    perPage: 5,
    perMove: 1,
    gap: '1.6rem',
    pagination: true,
    arrows: false,
    drag: true,
    breakpoints: {
      1280: {
        perPage: 4,
        gap: '1.4rem'
      },
      1024: {
        perPage: 3,
        gap: '1.2rem'
      },
      768: {
        perPage: 2,
        gap: '1rem'
      },
      480: {
        perPage: 1,
        gap: '1rem'
      }
    }
  }).mount();
});

/**
 * WOW + Animate.css: solo en elementos DIV contenedores (fadeIn).
 * No se añaden clases a títulos, párrafos u otros nodos de texto.
 */
function marianistaInitWowFadeIn() {
  if (document.body.classList.contains('wp-admin')) {
    return;
  }
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }
  if (typeof WOW === 'undefined') {
    return;
  }
  var selectors = ['section > div.contenedor', 'section div.contenedor.hero-slide__body', 'footer > div.contenedor', 'header.post-hero > div.contenedor', '.post-featured__inner.contenedor', 'article.post-body > div.contenedor'];
  var seen = new Set();
  selectors.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (node) {
      if (!(node instanceof HTMLDivElement)) {
        return;
      }
      if (seen.has(node)) {
        return;
      }
      seen.add(node);
      node.classList.add('wow', 'fadeIn');
    });
  });
  var wow = new WOW({
    boxClass: 'wow',
    animateClass: 'animated',
    offset: 40,
    mobile: true,
    live: false
  });
  wow.init();
}
function marianistaDomReady() {
  marianistaInitWowFadeIn();
  (0, _infraModal.marianistaInitInfraModal)();
  (0, _ipVidaLightbox.marianistaInitIpVidaLightbox)();
  (0, _primGaleria.marianistaInitPrimGaleria)();
  (0, _faqAccordion.marianistaInitFaqAccordion)();
  (0, _contactoVisitaModal.marianistaInitContactoVisitaModal)();
  (0, _egRevistasModal.marianistaInitEgRevistasModal)();
  (0, _egFotosGallery.marianistaInitEgFotosGallery)();
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', marianistaDomReady);
} else {
  marianistaDomReady();
}

},{"./contacto-visita-modal.js":1,"./eg-fotos-gallery.js":2,"./eg-revistas-modal.js":3,"./faq-accordion.js":4,"./infra-modal.js":6,"./ip-vida-lightbox.js":7,"./prim-galeria.js":8}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marianistaInitInfraModal = marianistaInitInfraModal;
/**
 * Modal de galería — sección Infraestructura (portada).
 */
function marianistaInitInfraModal() {
  var modal = document.getElementById('infraModal');
  if (!modal) {
    return;
  }
  var backdrop = modal.querySelector('.infra-modal__backdrop');
  var closeBtn = modal.querySelector('.infra-modal__close');
  var titleEl = modal.querySelector('.infra-modal__titulo');
  var panels = modal.querySelectorAll('[data-infra-panel]');
  var triggers = document.querySelectorAll('[data-infra-modal]');
  var splideMap = new WeakMap();
  var activePanel = null;
  function mountSplide(panel) {
    var root = panel.querySelector('.infra-modal__splide');
    if (!root || typeof Splide === 'undefined') {
      return null;
    }
    if (splideMap.has(root)) {
      var existing = splideMap.get(root);
      existing.go(0);
      return existing;
    }
    var splide = new Splide(root, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: 0,
      pagination: true,
      arrows: true,
      keyboard: true,
      drag: true
    });
    splide.mount();
    splideMap.set(root, splide);
    return splide;
  }
  function showPanel(index) {
    var panel = modal.querySelector("[data-infra-panel=\"".concat(index, "\"]"));
    if (!panel) {
      return;
    }
    panels.forEach(function (p) {
      p.hidden = p !== panel;
    });
    activePanel = panel;
    mountSplide(panel);
  }
  function openModal(index, titulo) {
    var panel = modal.querySelector("[data-infra-panel=\"".concat(index, "\"]"));
    if (!panel || panel.dataset.infraEmpty === '1') {
      return;
    }
    if (titleEl) {
      titleEl.textContent = titulo || '';
    }
    showPanel(index);
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    closeBtn === null || closeBtn === void 0 || closeBtn.focus();
  }
  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    activePanel = null;
  }
  triggers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var index = btn.getAttribute('data-infra-index');
      var titulo = btn.getAttribute('data-infra-titulo') || '';
      if (index === null || index === '') {
        return;
      }
      openModal(index, titulo);
    });
  });
  backdrop === null || backdrop === void 0 || backdrop.addEventListener('click', closeModal);
  closeBtn === null || closeBtn === void 0 || closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
}

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marianistaInitIpVidaLightbox = marianistaInitIpVidaLightbox;
/**
 * Lightbox de imagen única — .ip-vida (Inicial) y .prim-galeria (Primaria).
 */
function marianistaInitIpVidaLightbox() {
  var lightbox = document.getElementById('secLightbox');
  var lbImg = document.getElementById('secLightboxImg');
  var lbClose = document.getElementById('secLightboxClose');
  var lbBackdrop = document.getElementById('secLightboxBackdrop');
  var triggers = document.querySelectorAll('[data-ip-vida-lightbox], [data-prim-galeria-lightbox]');
  if (!lightbox || !lbImg || triggers.length === 0) {
    return;
  }
  function openLightbox(src, alt) {
    if (!src) {
      return;
    }
    lbImg.src = src;
    lbImg.alt = alt || '';
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    lbClose === null || lbClose === void 0 || lbClose.focus();
  }
  function closeLightbox() {
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    lbImg.removeAttribute('src');
  }
  triggers.forEach(function (btn) {
    var startX = 0;
    var startY = 0;
    var dragged = false;
    btn.addEventListener('pointerdown', function (e) {
      startX = e.clientX;
      startY = e.clientY;
      dragged = false;
    });
    btn.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - startX) > 10 || Math.abs(e.clientY - startY) > 10) {
        dragged = true;
      }
    });
    btn.addEventListener('click', function (e) {
      var _btn$querySelector, _btn$querySelector2;
      if (dragged) {
        return;
      }
      e.preventDefault();
      var src = btn.getAttribute('data-full') || ((_btn$querySelector = btn.querySelector('img')) === null || _btn$querySelector === void 0 ? void 0 : _btn$querySelector.getAttribute('src')) || '';
      var alt = btn.getAttribute('data-alt') || ((_btn$querySelector2 = btn.querySelector('img')) === null || _btn$querySelector2 === void 0 ? void 0 : _btn$querySelector2.getAttribute('alt')) || '';
      openLightbox(src, alt);
    });
  });
  lbClose === null || lbClose === void 0 || lbClose.addEventListener('click', closeLightbox);
  lbBackdrop === null || lbBackdrop === void 0 || lbBackdrop.addEventListener('click', closeLightbox);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox.classList.contains('is-open')) {
      closeLightbox();
    }
  });
}

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marianistaInitPrimGaleria = marianistaInitPrimGaleria;
/**
 * Carrusel galería — página Primaria (.prim-galeria__splide)
 */
function marianistaInitPrimGaleria() {
  if (typeof Splide === 'undefined') {
    return;
  }
  document.querySelectorAll('.prim-galeria__splide').forEach(function (el) {
    if (el.dataset.primGaleriaMounted === '1') {
      return;
    }
    el.dataset.primGaleriaMounted = '1';
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    new Splide(el, {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      gap: '1.6rem',
      pagination: true,
      arrows: false,
      drag: true,
      trimSpace: false,
      flickMaxPages: 1,
      speed: reducedMotion ? 0 : 450,
      easing: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      breakpoints: {
        1280: {
          perPage: 3,
          gap: '1.4rem'
        },
        1024: {
          perPage: 2,
          gap: '1.2rem'
        },
        768: {
          perPage: 1,
          gap: '1rem'
        }
      }
    }).mount();
  });
}

},{}]},{},[5])

